import type { TFunction } from 'i18next';
import type { ConfigObject } from '../../_configs/types';
import type { FluxStoreModuleContent } from '../../_flux/types';
import mapFacets from '../../_json/mapFacets';
import sAttr from '../../_json/s_attr';
import type { Facets, FacetsService, Filter } from '../../_types/Car';
import stringToSlug from '../string-to-slug';
import checkUndefinedNullOrEmpty from '../tools/checkUndefinedNullOrEmpty';

export default function getSearchString(
    filter: Filter,
    facets: Facets,
    viewOptions: FluxStoreModuleContent['viewOptions'],
    fiz: boolean,
    questionMark: boolean,
    translate: TFunction,
    settings: ConfigObject,
    octo: true
): { keyword: string; category: string }[];
export default function getSearchString(
    filter: Filter,
    facets: Facets,
    viewOptions: FluxStoreModuleContent['viewOptions'],
    fiz: boolean,
    questionMark: boolean,
    translate: TFunction,
    settings: ConfigObject,
    octo?: false | undefined
): string;
export default function getSearchString(
    filter: Filter,
    facets: Facets,
    viewOptions: FluxStoreModuleContent['viewOptions'],
    fiz: boolean,
    questionMark: boolean,
    translate: TFunction,
    settings: ConfigObject,
    octo?: boolean
): string | { keyword: string; category: string }[] {
    const searchArray = [];
    const searchOcto: { keyword: string; category: string }[] = [];
    const mappedFacets = mapFacets(translate);
    const sAttrTranslate = sAttr(translate);
    if (!octo && !checkUndefinedNullOrEmpty(viewOptions) && !checkUndefinedNullOrEmpty(viewOptions?.car)) {
        searchArray.push(viewOptions?.car?.join('_carId'));
    } else if (!checkUndefinedNullOrEmpty(filter)) {
        if (fiz) searchArray.push(['fiz', 1].join('='));
        if (filter.moreCars && filter.moreCars > 1) {
            searchArray.push(['moreCars', filter.moreCars].join('='));
            searchOcto.push({ category: 'page', keyword: filter?.moreCars?.toString() });
        }
        for (let i = 0; i < Object.keys(filter).length; i++) {
            const key = Object.keys(filter)[i];
            const value = filter?.[key];
            if (key === 'ia') {
                const searchStringAus = [];
                Object.keys(sAttrTranslate).map(function (catAus) {
                    sAttrTranslate[catAus].map(function (aus) {
                        if (value.includes(aus.i)) {
                            searchStringAus.push(aus.t);
                            searchOcto.push({ category: key, keyword: aus?.t });
                        }
                    });
                });
                if (searchStringAus.length > 0) {
                    searchArray.push([key, stringToSlug(searchStringAus.join(','))].join('='));
                }
            } else if (key === 'motoren' || key === 'akttypList' || key === 'Farben' || key === 'fd') {
                const facet = mappedFacets?.[key];
                const array = facets[facet?.facetName as keyof FacetsService];
                const title = facet?.filterName;

                if (!checkUndefinedNullOrEmpty(title) && !checkUndefinedNullOrEmpty(value)) {
                    const valueArr = [];
                    value?.map(function (val) {
                        const text = array?.find((a) => a?.i === val)?.t;
                        valueArr.push(text);
                        searchOcto.push({ category: key, keyword: text });
                    });
                    searchArray.push([key, stringToSlug(valueArr.join(','))].join('='));
                }
            } else {
                const facet = mappedFacets?.[key];
                const array = facets[facet?.facetName as keyof FacetsService];
                const title = facet?.filterName;

                if (!checkUndefinedNullOrEmpty(title) && !checkUndefinedNullOrEmpty(value) && value !== -100 && value !== '-100' && value !== false) {
                    if (Array.isArray(value)) {
                        if (!checkUndefinedNullOrEmpty(value[0]) && value[0] !== -100 && value[0] !== '-100' && value[0] !== false) {
                            searchArray.push([key + 'Von', value[0]].join('='));
                            searchOcto.push({ category: key + 'Von', keyword: value[0] });
                        }
                        if (!checkUndefinedNullOrEmpty(value[1]) && value[1] !== -100 && value[1] !== '-100' && value[1] !== false) {
                            searchArray.push([key + 'Bis', value[1]].join('='));
                            searchOcto.push({ category: key + 'Bis', keyword: value[1] });
                        }
                    } else {
                        const text = key === 'freier_text' ? value : ['sofort', 'aktion'].includes(key) ? 'Ja' : array?.find((a) => a?.i === value)?.t;
                        searchArray.push([key, stringToSlug(text)].join('='));
                        searchOcto.push({ category: key, keyword: stringToSlug(text) });
                    }
                }
            }
        }
    }
    if (!checkUndefinedNullOrEmpty(settings?.general?.searchPathSearch)) {
        searchArray.unshift(settings?.general?.searchPathSearch.replace('?', ''));
    }

    if (octo) {
        return searchOcto;
    }

    const searchString = searchArray.join('&');

    return (questionMark ? '?' : '') + searchString?.substring(0, searchString.length - (searchString.endsWith('&') ? 1 : 0));
}
